<template>
  <vx-card no-shadow>

    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar size="70px" class="mr-4 mb-4" />
    </div>

    <!-- Info -->
    <vs-input class="w-full mb-base" label-placeholder="名稱" v-model="userInfo.name"></vs-input>
    <vs-input class="w-full" label-placeholder="Email" v-model="userInfo.email"></vs-input>
    <vs-input class="w-full my-base" label-placeholder="店別" v-model="userInfo.store"></vs-input>
    <vs-input class="w-full my-base" label-placeholder="權限" v-model="userInfo.rule"></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveUserInfo">儲存</vs-button>
    </div>
  </vx-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
  data () {
    return {
      userInfo:{}
    }
  },
  methods: {
    saveUserInfo () {
      const user = firebase.auth().currentUser
      const db = firebase.firestore()
      const userRef = db.collection('user').doc(user.uid)
      userRef.update({
        name: this.userInfo.name,
        store:this.userInfo.store,
        email:this.userInfo.email,
        user_type: this.userInfo.rule
      })
    }
  },
  created () {
    const user = firebase.auth().currentUser
    const db = firebase.firestore()
    const userRef = db.collection('user').doc(user.uid)

    // 檢查是否在資料庫內
    userRef.get().then((doc) => {
      if (doc.exists) {
        const getUserData = doc.data()
        this.userInfo = getUserData
      }
    }).catch(function (error) {
      console.log('Error getting document:', error)
    })
  }
}
</script>
